import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Layout from "@/components/Page/Layout";
import Accreditation from "@/components/Page/Accreditation";
import { TFunction } from "next-i18next";
import { serverSidePage } from "@/utils/serverSide";
import { Website } from "@/types/website";
import { GetServerSideProps } from "next";

type Props = {
  website: Website;
};

export const AccreditationPage = ({ website }: Props): React.ReactElement => (
  <Accreditation website={website} rounded={false} />
);

AccreditationPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website } = page.props;

  return (
    <Layout title={t("website.accreditations")} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    ...(await serverSidePage(query, req, false, "accreditations")),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default AccreditationPage;
